import { v4 as uuidv4 } from "uuid";

// model mapper
export const modelMapper = (model) => {
  return model.map((item) => {
    return {
      ...item,
      key: uuidv4(),
    };
  });
};

// flight model mapper
export const flightDestinationModelMapper = (model) => {
  return model.map((item) => {
    return {
      ...item,
      airports: item.airports && item.airports.length ? item.airports.map(airport => {
        return {
          ...airport,
          key: uuidv4(),
        };
      }) : null,
      key: uuidv4(),
    };
  });
};